import { getRecipientRealId } from '../../../../utils/email'
import { SEARCH_KEY } from '../EmailRecipientsField.constants'
import {
  addInputValue,
  splitValidAndInvalidEmails,
} from '../EmailRecipientsField.utils'

export function getExcludeApiParam(items) {
  if (items.length === 0) {
    return null
  }

  const exclude = items.reduce((acc, item) => {
    const realId = getRecipientRealId(item)

    if (realId !== null && item.email) {
      acc.push([realId, item.email])
    }

    return acc
  }, [])

  return exclude.length > 0 ? { exclude } : null
}

export function isEmailInputComplete(value) {
  if (/;$/.test(value)) {
    return true
  }

  // a trailing space only completes the input when it contains at least one
  // valid email (matching the paste flow, which commits valid segments and
  // drops invalid ones), so free-text search is not committed mid-typing
  return /\s$/.test(value) && splitValidAndInvalidEmails(value).valid.length > 0
}

export function getUpdatedRecipientsValue(input, currentItems) {
  const { invalid, valid } = splitValidAndInvalidEmails(input)

  return {
    items: addInputValue(currentItems, ...valid),
    search: invalid.join('; '),
  }
}

export function getRecipientsSearchParam(searchValue) {
  return searchValue ? { [SEARCH_KEY]: searchValue } : null
}
